import {useField} from 'formik';
import {isBoolean} from 'lodash';
import {useCallback, useMemo} from 'react';

import {Select, SelectProps} from 'components/UIKit/Select';
import {Option} from 'interfaces/option';

type Props = {
    name: string;
    options: Option<any, string>[];
    hidePlaceholder?: boolean;
} & Partial<SelectProps>;

export const SelectFormik: React.FC<Props> = ({name, hasError: hasErrorProp, ...rest}: Props) => {
    const [field, meta, helpers] = useField(name);

    const hasError = useMemo<boolean>(() => {
        if (isBoolean(hasErrorProp)) {
            return hasErrorProp;
        }

        return meta.error && (meta.touched || meta.value) ||
            (meta.touched && !meta.value && rest.required);
    }, [meta, hasErrorProp, rest]);

    const handleChange = useCallback((newValue) => {
        helpers.setValue(newValue);
    }, [helpers]);

    return <Select {...rest} {...field} value={field.value} hasError={hasError} errorMessage={meta.error} onChange={handleChange} />;
};
